import {
    LOGIN_REQUESTED,
    LOGIN_SUCCEEDED,
    LOGIN_FAILED,
    LOGOUT_REQUESTED,
    CLEAR_ERROR_MESSAGES,
    PAYMENT_FAILED,
    PAYMENT_REQUESTED,
    PAYMENT_SUCCEEDED,
    UPDATE_USER_REQUESTED,
    SIGNUP_REQUESTED,
    SIGNUP_SUCCEEDED,
    SIGNUP_FAILED,
    ROLE_SWITCH_REQUESTED,
    ROLE_SWITCH_SUCCEEDED,
    ROLE_SWITCH_FAILED,
    FB_LOGIN_REQUESTED,
    PARTNER_SIGNUP_REQUESTED,
    PARTNER_SIGNUP_SUCCESSFUL,
    PARTNER_SIGNUP_FAILED,
    FORGOT_PASSWORD_REQUESTED,
    FORGOT_PASSWORD_SUCCEEDED,
    FORGOT_PASSWORD_FAILED,
    VERIFICATION_CODE_SET,
    RESET_PASSWORD_REQUESTED,
    RESET_PASSWORD_SUCCEEDED,
    RESET_PASSWORD_FAILED,
    CLEAR_FORGOT_FLAGS,
    UPDATE_PARTNER_LICENSE,
    GET_PARTNER_LICENSE,
    GET_PACKAGE_PRICING_FAILED,
    GET_PACKAGE_PRICING_SUCCESSFUL,
    GET_PACKAGE_PRICING_REQUEST,
    GET_PARTNER_LIST_FAILED,
    GET_PARTNER_LIST_REQUEST,
    GET_PARTNER_LIST_SUCCESSFUL,
    GET_PARTNER_TOKEN_FAILED,
    GET_PARTNER_TOKEN_REQUEST,
    GET_PARTNER_TOKEN_SUCCESSFUL,
    GET_REFRESH_TOKEN_FAILED,
    GET_REFRESH_TOKEN_SUCCESSFUL,
    GET_REFRESH_TOKEN_REQUEST,
    SET_SELECTED_PARTNER,
    RESET_VIEW_AS,
    PERMISSIONS_REQUESTED,
    PERMISSIONS_SUCCEEDED,
} from './constants';

export function loginRequested(
    userCreds,
    activePackage,
    activePackagePrice,
    activePackageKey,
    activePackageId,
) {
    return {
        type: LOGIN_REQUESTED,
        userCreds,
        activePackage,
        activePackagePrice,
        activePackageKey,
        activePackageId,
    };
}

export function fbLoginRequested(
    userCreds,
    activePackage,
    activePackagePrice,
    activePackageKey,
    activePackageId,
) {
    return {
        type: FB_LOGIN_REQUESTED,
        userCreds,
        activePackage,
        activePackagePrice,
        activePackageKey,
        activePackageId,
    };
}

export function getUserPermissionsAgain() {
    return {
        type: PERMISSIONS_REQUESTED,
    };
}
export function gotUserPermissions() {
    return {
        type: PERMISSIONS_SUCCEEDED,
    };
}

export function loginFailed(loginError) {
    return {
        type: LOGIN_FAILED,
        loginError,
    };
}

export function loginSucceeded(user) {
    return {
        type: LOGIN_SUCCEEDED,
        user,
    };
}

export function signUpRequested(
    userCreds,
    activePackage,
    activePackagePrice,
    activePackageKey,
    subscription,
    activePackageId,
) {
    return {
        type: SIGNUP_REQUESTED,
        userCreds,
        activePackage,
        activePackagePrice,
        activePackageKey,
        subscription,
        activePackageId,
    };
}

export function signUpSucceeded(user) {
    return {
        type: SIGNUP_SUCCEEDED,
        user,
    };
}

export function signUpFailed(signUpError) {
    return {
        type: SIGNUP_FAILED,
        signUpError,
    };
}

export function paymentRequested(
    tokenCreds,
    activePackage,
    activePackagePrice,
    activePackageKey,
    activePackageId,
) {
    return {
        type: PAYMENT_REQUESTED,
        tokenCreds,
        activePackage,
        activePackagePrice,
        activePackageKey,
        activePackageId,
    };
}

export function paymentFailed(paymentError) {
    return {
        type: PAYMENT_FAILED,
        paymentError,
    };
}

export function paymentSucceeded(payment) {
    return {
        type: PAYMENT_SUCCEEDED,
        payment,
    };
}

export function logoutRequested() {
    return {
        type: LOGOUT_REQUESTED,
    };
}

export function updateUserRequested(user) {
    return {
        type: UPDATE_USER_REQUESTED,
        user,
    };
}

export function clearErrorMessages() {
    return {
        type: CLEAR_ERROR_MESSAGES,
    };
}

export function roleSwitchRequested(requestedRole) {
    return {
        type: ROLE_SWITCH_REQUESTED,
        requestedRole,
    };
}

export function roleSwitchSucceeded(switchedRole) {
    return {
        type: ROLE_SWITCH_SUCCEEDED,
        switchedRole,
    };
}

export function roleSwitchFailed(roleSwitchError) {
    return {
        type: ROLE_SWITCH_FAILED,
        roleSwitchError,
    };
}

export function partnerSignupRequested(partnerDetails) {
    console.log('Partner Signup Requested Action');
    return {
        type: PARTNER_SIGNUP_REQUESTED,
        partnerDetails,
    };
}

export function partnerSignupSuccessful({ roles, rolePermissions }) {
    return {
        type: PARTNER_SIGNUP_SUCCESSFUL,
        roles,
        rolePermissions,
    };
}

export function clearForgotFlags() {
    return {
        type: CLEAR_FORGOT_FLAGS,
    };
}

export function verificationCodeRequested(code) {
    return {
        type: VERIFICATION_CODE_SET,
        code,
    };
}

export function resetPasswordRequested(password) {
    return {
        type: RESET_PASSWORD_REQUESTED,
        password,
    };
}

export function resetPasswordSucceeded(message) {
    return {
        type: RESET_PASSWORD_SUCCEEDED,
        message,
    };
}

export function resetPasswordFailed(error) {
    return {
        type: RESET_PASSWORD_FAILED,
        error,
    };
}

export function partnerSignupFailed(error) {
    return {
        type: PARTNER_SIGNUP_FAILED,
        error,
    };
}

export function forgotPasswordRequested(email) {
    return {
        type: FORGOT_PASSWORD_REQUESTED,
        email,
    };
}

export function forgotPasswordSucceeded(message) {
    return {
        type: FORGOT_PASSWORD_SUCCEEDED,
        message,
    };
}

export function forgotPasswordFailed(error) {
    return {
        type: FORGOT_PASSWORD_FAILED,
        error,
    };
}

export function getPartnerLicense() {
    return {
        type: GET_PARTNER_LICENSE,
    };
}
export function updatePartnerLicense(partnerLicense) {
    return {
        type: UPDATE_PARTNER_LICENSE,
        partnerLicense,
    };
}

export function getPackagePricingSucceeded(pricing) {
    return {
        type: GET_PACKAGE_PRICING_SUCCESSFUL,
        pricing,
    };
}

export function getPackagePricingFailed(error) {
    return {
        type: GET_PACKAGE_PRICING_FAILED,
        error,
    };
}

export function getPackagePricingRequest() {
    return {
        type: GET_PACKAGE_PRICING_REQUEST,
    };
}

export function getPartnerListSucceeded(partners) {
    return {
        type: GET_PARTNER_LIST_SUCCESSFUL,
        partners,
    };
}

export function getPartnerListFailed(error) {
    return {
        type: GET_PARTNER_LIST_FAILED,
        error,
    };
}

export function getPartnerListRequest() {
    return {
        type: GET_PARTNER_LIST_REQUEST,
    };
}

export function getPartnerTokenSucceeded(partner) {
    return {
        type: GET_PARTNER_TOKEN_SUCCESSFUL,
        partner,
    };
}

export function getPartnerTokenFailed(error) {
    return {
        type: GET_PARTNER_TOKEN_FAILED,
        error,
    };
}

export function getPartnerTokenRequest(partnerId) {
    return {
        type: GET_PARTNER_TOKEN_REQUEST,
        partnerId,
    };
}

export function getRefreshTokenSucceeded(user) {
    return {
        type: GET_REFRESH_TOKEN_SUCCESSFUL,
        user,
    };
}

export function getRefreshTokenFailed(error) {
    return {
        type: GET_REFRESH_TOKEN_FAILED,
        error,
    };
}

export function getRefreshTokenRequest() {
    return {
        type: GET_REFRESH_TOKEN_REQUEST,
    };
}

export function setSelectedPartner(value) {
    return {
        type: SET_SELECTED_PARTNER,
        value,
    };
}

export function resetViewAs(value) {
    return {
        type: RESET_VIEW_AS,
        value,
    };
}
